// extracted by mini-css-extract-plugin
export var cartContainer = "_nk-4";
export var gray = "_nk-1";
export var itemContainer = "_nk-2";
export var itemDetails = "_nk-3";
export var strong = "_nk-0";